import * as React from 'react';
import styled from 'styled-components';
import UserIcon from './Icon/Kaizen/Profile';
import BuildingSmallIcon from './Icon/Kaizen/BuildingSmall';

type avatarType = 'organization';

const Img = styled.img`
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: x-small;
  background-color: #c3cbdd;
  overflow: hidden;
  color: inherit;
`;

const Icon = styled.div`
  display: inline-block;
  line-height: 0;
`;

class Avatar extends React.PureComponent<{ src: string; username: string; type?: avatarType }, {}> {
  public render() {
    if (this.props.src) {
      return <Img src={this.props.src} alt={this.props.username} title={this.props.username} />;
    } else {
      if (this.props.type === 'organization') {
        return (
          <Icon title={this.props.username}>
            <BuildingSmallIcon size={30} />
          </Icon>
        );
      } else {
        return (
          <Icon title={this.props.username}>
            <UserIcon size={30} />
          </Icon>
        );
      }
    }
  }
}

export default Avatar;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/base/Avatar.tsx